import React from 'react';
import './generalInfo.scss';
import DrinkElement from '../drinkList/DrinkElement';
import { Divider } from '@mui/material';
import { FaCheese } from "react-icons/fa6";
import { TiWarningOutline } from "react-icons/ti";


function generalInfo(props: any) {
    return (
        <>
            <Divider className='pt-2' />
            <div className='mt-2 footer-formaggi' >
            <h1><TiWarningOutline /></h1>
                <div className='formaggi-container'>
                    <h2>
                        <FaCheese className='mr-2' />
                    </h2>
                    <div>
                        I formaggi utilizzati nei piatti provenienti dalle aziende agricole sono a latte crudo
                    </div>
                    <h2>
                        <FaCheese className='ml-2' />
                    </h2>
                </div>
                <Divider className='pt-2' />
            </div>
            <div className='general-info-container'>
                <DrinkElement element='Coperto' price={props.various?.coperto} />
                <div className='mt-2'>

                    Il pane e la pasta fresca sono preparati rigorosamente da noi
                </div>
                <div className='mt-1'>

                    Se hai allergie o intolleranze alimentari comunicalo al nostro personale di sala

                    Alcuni prodotti da noi preparati potrebbero essere abbattuti e congelati al momento della produzione
                </div>
            </div>
            <div className='general-info-container mt-0'>

            </div>
        </>
    );
}

export default generalInfo;